import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { RouterModule } from '@angular/router';
import { SupportTicketService } from '../../Model/Support/support-ticket.service';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { CommonService } from '../../Model/Common/common.service';
import { SessionService } from '../../Util/Session/session.service';
import { NgbActiveModal, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../../Model/utility/utility.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { ComboService } from '../../Model/Combo/combo.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-assigned-to',
  standalone: true,
  imports: [FormsModule, CommonModule, LoaderComponent, RouterModule, NgbModule, NgSelectModule],
  templateUrl: './assigned-to.component.html',
  styleUrl: './assigned-to.component.scss'
})
export class AssignedToComponent {
  @Input() InputData: any;
  isDisabled: boolean = false;
  UserMaster: any = null;
  UserId: any = null;
  TodayDate: any = null;
  UserEmail: any = null;
  ComplaintTypeData: any[] = [];
  ESS_ComplaintTypeId: any = null;
  Remarks : string = ''
  constructor(
    private support: SupportTicketService,
    private dateFormate: CustomDateParserFormatter,
    protected common: CommonService,
    private sessionService: SessionService,
    private modalService: NgbModal,
    private utility: UtilityService,
    private toast: ToastService,
    private combo: ComboService,
    public activeModal: NgbActiveModal,
    private tooltip: TooltipService,
  ) {
    //this.User = this.sessionService.GetUserDetails();
    this.common.getPageRights();
    //this.ESS_ComplaintTypeId = this.InputData.ESS_ComplaintTypeId;

    //this.SelectDate('RegistrationDate', null, null);
  }

  // SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
  //   this.isDisabled = true;
  //   return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
  //     next: (response) => {
  //       if (SelectType == 'RegistrationDate') {
  //         this.TodayDate = response.Table[0].RegistrationDate;
  //       }
  //       this.isDisabled = false;
  //     },
  //     complete: () => { },
  //     error: (error) => {
  //       this.isDisabled = false;
  //     },
  //   });
  // }
  ngOnInit() {
    //console.log(this.InputData.ESS_ComplaintTypeId);
    this.ComboLoad('ComplaintType');
    this.ComboLoad('UserMaster');
    this.ESS_ComplaintTypeId = this.InputData.ESS_ComplaintTypeId
  }

  Close(type: boolean) {
    this.activeModal.close(type);
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true;
    this.combo.ComboLoad({
      'Combotype': Combotype,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'UserMaster') {
          this.UserMaster = response.ComboLoad;
        } else if (Combotype == 'ComplaintType') {
          this.ComplaintTypeData = response.ComboLoad;
        }
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async save(type: string) {
    await this.common.getPageRights();
    if (this.ESS_ComplaintTypeId === '' || this.ESS_ComplaintTypeId === null) {
      this.toast.show({ message: 'Please select Complaint Type.', type: toastTypeEnum.warning });
      return
    }
    if (this.UserId === '' || this.UserId === null) {
      this.toast.show({ message: 'Please select User.', type: toastTypeEnum.warning });
      return
    }
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to save ?'
    modalRef.result.then((result: any) => {
      if (this.common.PageRight.IsAdd || this.common.PageRight.IsEdit) {
        if (result) {
          this.SaveUpdate(type);
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {

    });
  }
  SaveUpdate(type: string) {
    const Detail = {
      SelectType: 'U',
      ESS_HelpDeskRequestId: this.InputData.ESS_HelpDeskRequestId,
      ESS_ComplaintTypeId: this.ESS_ComplaintTypeId,//this.InputData.ESS_ComplaintTypeId,
      AdditionalDetails: this.InputData.AdditionalDetails,
      EmpMasterId: this.InputData.EmpMasterId,
      ContactNo: this.InputData.ContactNo,
      Description: this.InputData.Description,
      Status: type,
      Remarks: this.Remarks,
      UserId: this.InputData.UserId,
      Attachment: this.InputData.Attachment,
      AssignedTo: this.UserId,

      toMailId: this.UserEmail,//this.InputData.toMailId,
      ticketID: this.InputData.ESS_HelpDeskRequestId,
      assignedbyName: this.InputData.assignedbyName,
      ticketDescription: this.InputData.Description,
      ticketRaisedDate: this.InputData.ticketRaisedDate,
      companyName: this.InputData.companyName
    }
    this.isDisabled = true;
    this.support.ESS_HelpDeskRequest_Insert(Detail).subscribe({
      next: (data) => {
        if (data.Error_Code == '453') {
          this.isDisabled = false
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.Close(true)
            }
          });
        }
        else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
  }

  onUserChange(): void {
    const selectedUserId = this.UserId;
    const selectedUser = this.UserMaster.find((user: { UserMasterId: any; }) => user.UserMasterId === selectedUserId);
    if (selectedUser) {
      this.UserEmail = selectedUser.EmailId;
    } else {
      console.log('User not found.');
    }
  }
}
